<template>
  <div style="margin-top: 50px">
    <mt-header title="工单录入">
      <router-link slot="left" to="">
        <mt-button @click="formReturn" icon="back">返回</mt-button>
      </router-link>
      <div slot="right">
        <mt-button class="m-1" @click="formSubmit(-2)"
          ><img slot="icon" src="@/assets/success.png" width="24" height="24" />
        </mt-button>
      </div>
    </mt-header>
    <scroll-body
      class="m-2"
      :minheight="200"
      :outheight="160"
      :isScroll="true"
      @resize="resize"
    >
      <template slot="content">
        <div>
          <mt-radio
            title="工单类型"
            v-model="data.pst.pstType"
            :options="[
              { label: '网络留留言', value: '0' },
              { label: '负面舆情', value: '1' },
            ]"
            @blur.native.capture="checkPstType"
            :state="filedStatus.pstTypeStatus"
          />
          <mt-field
            label="标题"
            v-model="data.pst.title"
            placeholder="请输入标题"
            @blur.native.capture="checkInputTitle"
            :state="filedStatus.titleStatus"
          />
          <mt-field
            label="地址"
            v-model="data.pst.pstUrl"
            placeholder="请输入网址"
            @blur.native.capture="checkInpuPstUrl"
            :state="filedStatus.pstUrlStatus"
          />
          <mt-field
            label="发贴人"
            v-model="data.pst.name"
            placeholder="请输入网友名称"
            @blur.native.capture="checkPstName"
            :state="filedStatus.pstNameStatus"
          />
          <mt-field
            label="时间"
            v-model="data.pst.postingTime"
            placeholder="请输入发贴时间"
            @blur.native.capture="checkPostTime"
            :state="filedStatus.postingTimeStatus"
          />
          <mt-field
            label="来源"
            v-model="data.pst.pstSource"
            placeholder="请输入来源"
            @blur.native.capture="checkPstSource"
            :state="filedStatus.pstSourceStatus"
          />
          <mt-field label="内容" disabled />
          <mt-field
            type="textarea"
            rows="5"
            v-model="data.pst.pstContent"
            placeholder="请输入帖子内容"
            @blur.native.capture="checkPstContent"
            :state="filedStatus.pstContentStatus"
          />
        </div>
      </template>
    </scroll-body>
  </div>
</template>
  
<script>
import ScrollBody from "@/components/ScrollBody.vue";
export default {
  components: {
    ScrollBody,
  },
  created() {
    this.pstApi.setWindowTitle("创建工单信息");
    this.data.user = this.pstApi.getUserData();
    //console.log(this.data.user)
  },
  data() {
    return {
      filedStatus: {
        pstTypeStatus: "",
        titleStatus: "",
        pstUrlStatus: "",
        pstNameStatus: "",
        postingTimeStatus: "",
        pstSourceStatus: "",
        pstContentStatus: "",
      },
      bodyStyle: {
        overflowY: "auto",
        overflowX: "hidden",
        listStyle: "none",
        height: 420 + "px",
      },
      tabPosition: "top",
      //数据项
      data: {
        statusName: "",
        pstTypeName: "",
        pst: {
          pstType: "1",
          title: "",
          pstUrl: "",
          name: "",
          postingTime: "",
          pstSource: "",
          pstContent: "",
        },
        nodes: [],
        user: "",
      },
    };
  },
  methods: {
    resize(height) {
      this.bodyStyle.height = height - 10 + "px";
    },
    formReturn() {
      this.$router.back();
    },
    async formSubmit(category) {
      if (this.checkPstType() == "error") {
        this.$toast("工单类型错误");
        return;
      }
      if (this.checkInputTitle() == "error") {
        this.$toast("工单标题不能为空");
        return;
      }
      if (this.checkInpuPstUrl() == "error") {
        this.$toast("来源地址错误");
        return;
      }
      if (this.checkPstName() == "error") {
        this.$toast("发贴人不能为空");
        return;
      }
      if (this.checkPostTime() == "error") {
        this.$toast("发贴时间不能为空");
        return;
      }
      if (this.checkPstSource() == "error") {
        this.$toast("来源不能为空");
        return;
      }
      if (this.checkPstContent() == "error") {
        this.$toast("贴子内容不能为空");
        return;
      }

      let pst = this.data.pst;
      this.pstApi
        .createNegative(
          pst.title,
          pst.pstUrl,
          pst.name,
          pst.postingTime,
          pst.pstSource,
          pst.pstContent,
          category,
          parseInt(pst.pstType)
        )
        .then((res) => {
          this.$toast("工单创建成功！");
          this.formReturn();
          //进入编辑页面
          //console.log(res)
          // let pstId = res.data.data;
          //console.log(pstId)
          // if (pstId) {
          //   this.$router.push({
          //     name: "EditNegative",
          //     params: { id: pstId },
          //   });
          // }
        })
        .catch((err) => {
          var message = "创建失败";
          if (err.response.data) {
            //console.log(err.response);
            message = err.response.data.Message;
          }
          this.$toast(message);
        });
    },
    //
    checkPstType() {
      var pstType = this.data.pst.pstType;
      if (pstType == 0 || pstType == 1) {
        this.filedStatus.pstTypeStatus = "success";
      } else {
        this.filedStatus.pstTypeStatus = "error";
      }
    },
    checkInputTitle() {
      var title = this.data.pst.title;
      if (title) {
        this.filedStatus.titleStatus = "success";
      } else {
        this.filedStatus.titleStatus = "error";
      }
    },
    checkInpuPstUrl() {
      var url = this.data.pst.pstUrl;
      // console.log(url)
      if (this.Common.isURL(url)) {
        this.filedStatus.pstUrlStatus = "success";
      } else {
        this.filedStatus.pstUrlStatus = "error";
      }
    },
    checkPstName() {
      var str = this.data.pst.name;
      if (this.Common.isNull(str)) {
        this.filedStatus.pstNameStatus = "error";
      } else {
        this.filedStatus.pstNameStatus = "success";
      }
    },
    checkPostTime() {
      var dt = this.data.pst.postingTime;
      // console.log(url)
      if (this.Common.isDate(dt)) {
        this.filedStatus.postingTimeStatus = "success";
      } else {
        this.filedStatus.postingTimeStatus = "error";
      }
    },
    checkPstSource() {
      var str = this.data.pst.pstSource;
      if (this.Common.isNull(str)) {
        this.filedStatus.pstSourceStatus = "error";
      } else {
        this.filedStatus.pstSourceStatus = "success";
      }
    },
    checkPstContent() {
      var str = this.data.pst.pstContent;
      if (this.Common.isNull(str)) {
        this.filedStatus.pstContentStatus = "error";
      } else {
        this.filedStatus.pstContentStatus = "success";
      }
    },
  },
};
</script>
  
<style lang="less" scoped>
/deep/.mint-cell {
  min-height: 32px;
}
/deep/ .mint-cell-wrapper {
  font-size: 14px;
}
/deep/ .mint-field .mint-cell-title {
  width: 60px;
}
/deep/input:disabled {
  background-color: #fff;
}
/deep/textarea:disabled {
  background-color: #fff;
}
/deep/textarea.mint-field-core {
  font-size: 14px;
}
</style>